exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1TVfj{padding-top:64px;padding-top:4rem;padding-left:128px;padding-left:8rem;width:100%;background-color:#fff}._3F1Zw{margin-bottom:86px;margin-bottom:5.375rem}._3F1Zw p{font-family:AvenirNextRegular,sans-serif;font-size:16px;font-size:1rem;line-height:24px;margin-bottom:16px;margin-bottom:1rem}._1_d5L{font-family:AvenirNextBold,sans-serif;color:#dd2160}._3DExD{font-family:IntroBold,sans-serif;font-size:24px;font-size:1.5rem;width:100%;border-bottom:3px solid #f5f5f5;padding-bottom:24px;padding-bottom:1.5rem;margin-bottom:14px;margin-bottom:.875rem;color:#043544}._1sjvJ{float:right;margin-right:85px;margin-top:3%}._1sjvJ img{width:25px}.W3fLe{display:inline-block}", ""]);

// exports
exports.locals = {
	"wrapper": "_1TVfj",
	"section": "_3F1Zw",
	"bold": "_1_d5L",
	"header": "_3DExD",
	"trashButton": "_1sjvJ",
	"testEdit": "W3fLe"
};